import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const features = [
    {
      icon: 'fa-users',
      title: 'Kundenverwaltung',
      description: 'Verwalten Sie alle Kundendaten zentral. Von Kontaktdaten bis zur kompletten Fahrzeughistorie - alles an einem Ort.'
    },
    {
      icon: 'fa-car',
      title: 'Fahrzeugverwaltung',
      description: 'Vollständige Fahrzeugdaten, Wartungshistorie, Mängel und Unfälle. Immer den Überblick über alle Fahrzeuge Ihrer Kunden.'
    },
    {
      icon: 'fa-wrench',
      title: 'Reparaturverwaltung',
      description: 'Erfassen Sie Reparaturen mit Materialien und Arbeitszeiten. Automatische Berechnung und direkte Rechnungserstellung.'
    },
    {
      icon: 'fa-file-invoice',
      title: 'Rechnungserstellung',
      description: 'Professionelle Rechnungen als PDF mit QR-Code für Kundenportal. Unterstützung für DE und CH Steuersysteme.'
    },
    {
      icon: 'fa-boxes',
      title: 'Inventarverwaltung',
      description: 'Lagerbestände im Blick, automatische Warnung bei niedrigem Bestand. Integration mit Einkäufen und Reparaturen.'
    },
    {
      icon: 'fa-calendar',
      title: 'Terminverwaltung',
      description: 'Planen Sie Termine effizient. Kunden können selbst Termine buchen über das Kundenportal.'
    },
    {
      icon: 'fa-chart-line',
      title: 'Berichte & KPIs',
      description: 'Umfassende Auswertungen und Kennzahlen. Umsatz, Gewinn, Top-Kunden und vieles mehr auf einen Blick.'
    },
    {
      icon: 'fa-database',
      title: 'Transparente Datenspeicherung',
      description: 'Ihre Daten werden im offenen JSON-Format gespeichert. Kein Vendor-Lock-in, volle Kontrolle über Ihre Daten.'
    }
  ];

  const benefits = [
    'Zeitersparnis durch Automatisierung',
    'Weniger Fehler durch zentrale Datenverwaltung',
    'Professionelle Rechnungen in Sekunden',
    'Immer den Überblick über alle Prozesse',
    'Kundenportal für besseren Service',
    'Transparente Datenspeicherung im JSON-Format'
  ];

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="beta-badge-hero">
            <span className="beta-label">BETA</span>
          </div>
          <h1 className="hero-title">
            <span className="logo-garage">Garage</span><span className="logo-desk">Desk</span>
          </h1>
          <p className="hero-subtitle">
            Moderne Software für Kfz-Werkstätten
          </p>
          <p className="hero-description">
            Verwalten Sie Kunden, Fahrzeuge, Reparaturen und Rechnungen effizient in einer zentralen Lösung. 
            Transparent, benutzerfreundlich und ohne Vendor-Lock-in.
          </p>
          <div className="hero-cta">
            <Link to="/login" className="btn-primary btn-large">
              Jetzt starten
            </Link>
            <Link to="/documentation" className="btn-secondary btn-large">
              Dokumentation
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Alle Funktionen für Ihre Werkstatt</h2>
          <p className="section-subtitle">
            GarageDesk bietet alles, was Sie für die professionelle Verwaltung Ihrer Werkstatt benötigen
          </p>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <i className={`fas ${feature.icon}`}></i>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Warum GarageDesk?</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-item">
                <i className="fas fa-check-circle"></i>
                <span>{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Bereit loszulegen?</h2>
          <p className="cta-description">
            Starten Sie noch heute und optimieren Sie Ihre Werkstattprozesse
          </p>
          <div className="cta-buttons">
            <Link to="/login" className="btn-primary btn-large">
              Kostenlos registrieren
            </Link>
            <Link to="/contact" className="btn-secondary btn-large">
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-links">
            <Link to="/login?demo=true">Werkstatt Demo</Link>
            <Link to="/customer-login?email=testkunde@example.com&password=test123">Kunde Demo</Link>
            <Link to="/customer-register">Kunde registrieren</Link>
            <Link to="/documentation">Dokumentation</Link>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/support">Support</Link>
            <Link to="/contact">Kontakt</Link>
          </div>
          <p className="footer-copyright">
            © 2025 GarageDesk. Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;

